import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .errorMessage {
    color: #ff2f2f;
    font-weight: 500;
    font-size: 10px;
    line-height: 100%;
  }

  .buttonContainer {
    padding: 20px 0 0;
    width: 100%;
    display: flex;
    justify-content: space-between;

    button {
      width: 130px;
    }
  }

  .step-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .previews {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .file-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
          display: flex;
          gap: 10px;
          align-items: center;

          label {
            text-align: left;
            font-size: 12px;
            width: 90px;
            flex: 0 0 auto;
            font-weight: 400;
          }

          .layout-select {
            width: 100%;
          }

          input {
            padding: 5px 11px;
          }
        }
      }
    }
  }
`;
